module.exports = __webpack_public_path__ + "static/media/arquivesIcons.6d6dd77a.svg";